<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="收款" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="860px">
    <div class="dialog__container">
      <!-- <div style="padding-bottom: 16px;">
        <el-button size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button size="mini" type="primary" class="plr28" plain @click="handleDelete">删除</el-button>
      </div> -->

      <el-table @selection-change="handleSelectionChange" max-height="430px" v-loading="tableLoading" :data="list"
        border >
        <!-- <el-table-column type="selection" width="40"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="makeDate" label="收款日期"></el-table-column>
        <el-table-column show-overflow-tooltip prop="money" label="收款金额"></el-table-column>
        <el-table-column show-overflow-tooltip prop="cardCode" label="卡号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
        <!-- <el-table-column label="操作" width="160px" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEditDict(scope.row)">编辑</el-button>
            <div class="btn-divide"></div>
            <el-button size="mini" type="text" @click="handleDeleteDict(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->

      </el-table>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span> -->
    <el-dialog :close-on-click-modal="false" :title="status === 'add' ? '新增催款' : '编辑催款'" :show-close="true"
      :visible="dialogVisible" :before-close="handleBeforeClose2" width="660px" append-to-body>
      <div>
        <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
          label-width="70px">

          <el-form-item label="收款日期:" prop="makeDate" class="input-with-col2 mr0">
            <el-date-picker v-model="form.makeDate" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="收款金额：" class="input-with-col2 mr0" prop="money">
            <el-input size="mini" type="number" v-model.trim="form.money" placeholder="请输入开票金额" clearable></el-input>
          </el-form-item>
          <el-form-item label="收款方式:" prop="card" class="input-with-col2 mr0">
            <el-select size="mini" v-model="form.card" filterable placeholder="请选择收款方式" clearable value-key="id">
              <el-option v-for="item in cardList" :key="item.id" :label="item.cardCode + '--' + item.cardName"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：" class="input-with-col2 mr0" prop="remark">
            <el-input size="mini" v-model.trim="form.remark" placeholder="请输入备注" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="plr28" size="mini" type="info" plain @click="handleCancel2">取消</el-button>
        <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm2">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  getReceiveCollectionList,
  deleteReceiveCollection,
  saveReceiveCollection
} from '@/api/ReceiveCollection'
import {
  getCardList
} from '@/api/Card'
export default {
  props: {
    detail: {
      required: true
    },
    appCode: {
      type: String
    }
  },
  data() {
    return {
      cardList: [],
      dialogVisible: false,
      tableLoading: false,
      list: [],
      multipleSelection: [],
      status: 'add',
      form: {
        makeDate: '',
        remark: ''
      },
      rules: {
        card: [{
          required: true,
          message: '请选择收款方式',
          trigger: 'blur'
        }],
        makeDate: [{
          required: true,
          message: '请选择开票时间',
          trigger: 'blur'
        }],
        money: [{
          required: true,
          message: '请输入开票金额',
          trigger: 'blur'
        }]
      },
      loadBtn: false
    }
  },
  methods: {
    async handleCardList() {
      const res = await getCardList({});
      if (res.code === 200) {
        this.cardList = res.data
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    async getListData() {
      this.tableLoading = true
      let queryData = {
        pageIndex: 1,
        pageSize: 10000,
        financialReceiveId: this.detail.id
      }
      const res = await getReceiveCollectionList(queryData)
      if (res.code === 200) {
        this.list = [...res.data.list]
      }
      this.tableLoading = false
    },
    handleAdd() {
      this.status = 'add'
      this.form = {
        makeDate: '',
        remark: ''
      }
      this.dialogVisible = true
    },
    handleEditDict(row) {
      this.status = 'edit'
      this.form = {
        ...row
      }
      this.form.card = {
        cardCode: this.form.cardCode,
        id: this.form.cardId
      };
      this.dialogVisible = true
    },
    // 多行删除
    handleDelete() {
      if (this.multipleSelection && this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一行')
        return
      }
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = []
          this.multipleSelection.forEach(item => {
            ids.push(item.id)
          })
          deleteReceiveCollection({
            idList: ids
          }).then(res => {
            if (res && res.code === 200) {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => { })
    },
    // 单行删除
    handleDeleteDict(row) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteReceiveCollection({
            idList: [row.id]
          }).then(res => {
            if (res && res.code === 200) {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => { })
    },
    handleBeforeClose(done) {
      this.$emit('cancel')
      done()
    },
    handleBeforeClose2(done) {
      this.dialogVisible = false
      done()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async handleConfirm() {
      this.$emit('confirm')
    },
    handleCancel2() {
      this.dialogVisible = false
    },
    handleConfirm2() {
      if (this.loadBtn) return
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loadBtn = true
          if (this.status === 'add') {
            this.form.financialReceiveId = this.detail.id
            this.form.cardId = this.form.card.id;
            this.form.cardCode = this.form.card.cardCode;
            delete this.form.card;
            saveReceiveCollection({
              ...this.form
            }).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.getListData()
              }
              this.loadBtn = false
            })
          } else if (this.status === 'edit') {
            saveReceiveCollection({
              ...this.form
            }).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.getListData()
              }
              this.loadBtn = false
            })
          }
        }
      })

    }
  },
  created() {
    this.getListData();
    this.handleCardList()
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
.dialog__container {
  .class_box {
    display: flex;
    margin-bottom: 20px;
    font-size: 12px;

    span {
      color: #CCCCCC;
    }

    .class_box_span_last {
      color: #666666;
      font-weight: 600;
    }

    .class_box_symbol {
      margin: 0 5px;
      color: #CCCCCC;
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Collect/components/CollectionList.vue